import React from 'react';
import * as yup from 'yup';
import { useStringsContext } from '../../../../../contexts/strings';
import { TextPoll, TextPollKeys } from '../../types';
import PollCard from '../poll-card';
import TextInputWithValidate, {
  InputWithValidateProps,
} from '../../../../common/input/text-input-with-validate';
import PollTextAlternatives from '../poll-text-alternatives';

const titleKey: TextPollKeys = 'title';

interface Props extends InputWithValidateProps {
  selectedPoll: TextPoll | null;
  selectedAbbrv: string;
  isEditing: boolean;
}

const PollTextDetailsCard = ({
  isEditing,
  selectedPoll,
  onValue,
  onValidation,
  hideValidationError,
}: Props) => {
  const { strings } = useStringsContext();

  return (
    <PollCard title={strings.polls.pollDetailsTitle}>
      <TextInputWithValidate
        name={titleKey}
        validation={yup.string().required(strings.validations.isRequired)}
        label={strings.polls.pollTextTitleLabel}
        helperText={strings.polls.pollTextTitleHelperText}
        value={selectedPoll?.[titleKey]}
        onValue={onValue}
        onValidation={onValidation}
        hideValidationError={hideValidationError}
      />
      <PollTextAlternatives
        alternatives={selectedPoll?.alternatives}
        isEditing={isEditing}
        onValue={onValue!}
        hideValidationError={hideValidationError}
        onValidation={onValidation}
      />
    </PollCard>
  );
};

export default PollTextDetailsCard;
